import ServiceBanner from './SkuItemBanner';

export default ServiceBanner;
